export default __webpack_public_path__ + "static/media/pre-login-bg.38ba7e19.svg";